export default "__VITE_ASSET__CsTRhfkd__"